import { createContext } from 'react';

import type { Separator, Size } from '@hrworks/sui-shared/types';

export type BreadcrumbContext = {
  size?: Size;
  separator?: Separator;
  uppercase?: boolean;
};

export const BreadcrumbContext = createContext<BreadcrumbContext>({} as BreadcrumbContext);
